<cdp-navbar></cdp-navbar>
<router-outlet></router-outlet>
<div class="auto-width-ng-select"></div>
<div *ngIf="navigating" class="loading-app-shield cdp-fade-in">
    <hc-progress-spinner [diameter]="64" [color]="'blue'"></hc-progress-spinner>
</div>

<!-- Show splash screen when not authenticated -->
<div class="base-app-shield blue-app-shield" *ngIf="(isAuthenticated$ | async) === false">
    <div id="bootstrap" class="center-children">
        <div id="logoContainer" class="center-children">
            <div id="initialLoaderLogo"></div>
        </div>
        <div id="triflame"></div>
        <div id="hcSplashSpinner" class="fade-spin"></div>
    </div>
</div>
